import * as types from './actions';

export default function reducer(
  state = {
    isFetchingTechnician: true,
    inviteUserModal: false,
    editUserModal: false,
    setDeleteUserModal: false,
    editUserData: null,
    deleteUserData: null,
    roleModalVal: false,
    showCustomers: false,
    showTechnician: false,
    allTechnician: [],
    allLoginCustomer: [],
    loginUser: {}
  },
  action
) {
  switch (action.type) {

    // eslint-disable-next-line no-fallthrough

    case types.LOGIN:
      return {
        ...state,
        loginUser: action.payload.data,
      };
    case types.TECHNICAIN_SIGNUP:
      return {
        ...state,
        allTechnician: action.payload.data,
      };
    case types.SET_CUSTOMER_LOGIN_USER:
      return {
        ...state,
        allLoginCustomer: action.payload.data,
      };
    case types.SIGNUP_SUCCESS:
      return {
        ...state,
        success: action.payload,
      };

    case types.SET_INVITE_USER_MODAL:
      return {
        ...state,
        inviteUserModal: action.payload.data,
      };
    case types.SET_EDIT_USER_MODAL:
      return {
        ...state,
        editUserModal: action.payload.data,
      };
    case types.SET_DELETE_USER_MODAL:
      return {
        ...state,
        setDeleteUserModal: action.payload.data,
      };
    case types.SET_EDIT_USER_DATA:
      return {
        ...state,
        editUserData: action.payload.data,
      };
    case types.SET_ROLE_MODAL:
      return {
        ...state,
        roleModalVal: action.payload.data,
      };
    case types.SET_ROLE_VALUE:
      return {
        ...state,
        roleValue: action.payload.data,
      };
    case types.SET_USER_ROLE:
      return {
        ...state,
        userRole: action.payload.data
      };
    case types.SET_DELETE_USER_DATA:
      return {
        ...state,
        deleteUserData: action.payload.data,
      };
    case types.FETCHING_TECHNICIANDATA:
      return {
        ...state,
        isFetchingTechnician: action.payload.data,
      };
    default:
      return state;
  }
}
